export enum GaEvent {
  page_view = 'vpage_view',

  // Offers
  open_lead = 'open_lead',
  generate_lead = 'generate_lead',
}
